import { useEffect, useState } from "react";

// Reveals `text` progressively for a ChatGPT-like streaming feel.
// Finishes in ~1.2-1.6s regardless of length (chunked reveal).
export default function TypewriterText({ text = "", speed = 14, onTick, onDone }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    setCount(0);
    if (!text) { onDone && onDone(); return; }
    const step = Math.max(1, Math.round(text.length / 90));
    let i = 0;
    const id = setInterval(() => {
      i += step;
      setCount(i);
      onTick && onTick();
      if (i >= text.length) {
        setCount(text.length);
        clearInterval(id);
        onDone && onDone();
      }
    }, speed);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [text]);

  return <>{text.slice(0, count)}</>;
}
